export default __webpack_public_path__ + "static/media/book_button.9a12c907.svg";